import { Read4SpeedCollections } from '@read4speed/firebase-collections';
import { FirestoreType } from '@read4speed/firebase-common-types';

import { getFirestore } from './firebaseInitialize';

export const collections = new Read4SpeedCollections(
  (getFirestore() as unknown) as FirestoreType
);
